module.exports = __webpack_public_path__ + "img/巨蟹座.c24d0d6a.svg";